const opportunityStageCategories = {
  open: { id: 'open', name: 'Open' },
  won: { id: 'won', name: 'Won' },
  lost: { id: 'lost', name: 'Lost' },
};

export default opportunityStageCategories;
